export default __webpack_public_path__ + "static/media/wallpaper_05.8fa03b03.jpg";